import type { FieldCodec } from 'v5/core/entity-values/values.types';
import { customFieldColumns } from './customFieldColumns';
import { findCustomFieldRowForRead } from './customFieldRows';
import { validateField, validation } from './validation';

function isEmpty(value: boolean | null): boolean {
  return value === null;
}

/** BOOLEAN custom field; `null` = not answered (distinct from `false`). */
export const booleanCodec: FieldCodec<'boolean'> = {
  decode(entity, spec, ctx) {
    const row = findCustomFieldRowForRead(entity, spec.definition.id, ctx);
    return row?.boolean_value ?? null;
  },
  encode(value) {
    return {
      type: 'custom',
      columns: customFieldColumns({ boolean_value: value })
    };
  },
  empty() {
    return null;
  },
  isEmpty,
  validate(value, spec) {
    return validateField(value, spec, isEmpty, () => validation.valid());
  }
};
